export const SAVE_HERO_IMAGE = 'SAVE_HERO_IMAGE';

export function saveHeroImage(heroImage) {
    return {
        type: SAVE_HERO_IMAGE,
        payload: heroImage,
    };
}
